import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import { TranslationDialogService } from "src/app/shared/translation-dialog/translation-dialog.service";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import { MasterData, Priority } from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";

@Component({
  selector: "app-priorities",
  templateUrl: "./priorities.component.html",
  styleUrls: ["./priorities.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrioritiesComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private masterDataService = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  readonly translationDialogService = inject(TranslationDialogService);

  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<Priority>;
  displayedColumns: string[] = [
    "name",
    "externalId",
    "metaId",
    "edit",
    "delete",
    "translations",
  ];
  priorities: Priority[] = [];

  ngOnInit(): void {
    const priorities = this.route.snapshot.data.priorities ?? [];
    this.priorities = sortByStringWithEmptyAtEnd(
      priorities,
      (item) => item.name,
    );
    // this.route.snapshot.data.priorities.sort((a, b) =>
    //   a.name.localeCompare(b.name)
    // );
    this.dataSource = new MatTableDataSource(this.priorities);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  savePriorityToApi(type: Priority) {
    this.masterDataService
      .updatePriority(type)
      .pipe(
        finalize(() => {
          this.masterDataService
            .getPriorities()
            .pipe(first())
            .subscribe((priorities) => {
              this.priorities = priorities;
              this.dataSource.data = this.priorities;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: () => this.masterDataService.savingErrorMessage(),
      });
  }

  updatePriority(t: Priority) {
    const priority = new Priority();
    Object.assign(priority, t);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: priority,
    });
    dialogRef.afterClosed().subscribe(async (data: Priority) => {
      if (data != null) {
        this.savePriorityToApi(data);
      }
    });
  }

  deletePriority(priority: Priority) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE,
    );
    this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddPriority() {
    const priority = new Priority();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: priority,
    });
    dialogRef.afterClosed().subscribe(async (data: Priority) => {
      if (data != null) {
        this.savePriorityToApi(data);
      }
    });
  }

  openTranslationsDialog(item: MasterData): void {
    this.translationDialogService.open(item, "Priority").subscribe((result) => {
      if (result) {
        item.translations = result;
        this.savePriorityToApi(item as Priority);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }
}
